import { Box } from "@mui/material";
import bannerSrc from "@arelia-assets/hq-banner.png";
import ImageHeader from "@arelia-components/layout/ImageHeader";
import theme from "src/theme";
import HqManagePresenter from "./HqManagePresenter";

export default function HqManageContainer() {
  return (
    <Box
      bgcolor={theme.palette.background.default}
      flexGrow={1}
      height={1}
      display="flex"
      flexDirection="column"
      gap={"34px"}
      sx={{
        overflowY: "auto",
      }}
    >
      <ImageHeader
        title="Settings"
        backgroundUrl={bannerSrc}
        dashboard
      ></ImageHeader>
      <Box p={5} pt={2}>
        <HqManagePresenter />
      </Box>
    </Box>
  );
}
